import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { userService } from '@/services/user_service'
import { useAuth } from '@/hooks/useAuth'
import { toast } from 'sonner'
import { useState } from 'react'

interface DeleteAlertProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  userId?: number
}

export function DeleteAlert({ open, onOpenChange, onConfirm, userId }: DeleteAlertProps) {
  const { token } = useAuth()
  const [isDeleting, setIsDeleting] = useState(false)
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>確定要刪除此使用者嗎？</AlertDialogTitle>
          <AlertDialogDescription>
            此操作無法復原。這將永久刪除此使用者的帳號和所有相關資料。
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>取消</AlertDialogCancel>
          <AlertDialogAction
            onClick={async () => {
              if (!userId) return

              setIsDeleting(true)
              try {
                const response = await userService.deleteUser(userId, token)
                if (response.success) {
                  toast.success('刪除成功')
                  onConfirm()
                } else {
                  toast.error('刪除失敗')
                }
              } catch {
                toast.error('刪除失敗')
              } finally {
                setIsDeleting(false)
                onOpenChange(false)
              }
            }}
            className="bg-destructive text-destructive-foreground"
            disabled={isDeleting}
          >
            {isDeleting ? '刪除中...' : '刪除'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
